/**
 * Sidebar product filter search
 * @module productFilterActiveSearch
 */

import $ from 'jquery';
import mergeOptions from 'styleguide/lib/merge-options';
import registerJQueryPlugin from '../lib/register-jquery-plugin';
import { get } from '../lib/props';
import './product-filter-count';

export const PLUGIN_NAME = 'productFilterActiveButton';

export const DEFAULTS = {
  clearAllText: get('rcProps.filter.clearAllText', 'Clear'),
};

const createCloseIcon = () => `<span class="icon icon--x icon--sm u-margin-l--sm">
  <svg viewBox="0 0 16 16" aria-hidden="true" focusable="false"
      role="presentation">
      <path
          d="M9.06 8l2.72-2.72A.75.75 0 0 0 10.72 4.22L8 6.94 5.28
             4.22A.75.75 0 0 0 4.22 5.28L6.94 8l-2.72 2.72A.75.75 0 1 0 5.28 11.78L8
             9.06l2.72 2.72a.75.75 0 0 0 1.061-1.061z">
      </path>
  </svg>
</span>`;

const createFilterButton = (text) => `<li class="horizontal-scroll__item
     horizontal-scroll__item--basis-none">
  <button class="btn btn--filters">
      ${text}
      ${createCloseIcon()}
  </button>
</li>`;

// Getting rid of Clear button for AB testing
const createContainerButtons = () => `<div class="horizontal-scroll u-margin-b--md u-width-plus-16">
  <ul
      class="horizontal-scroll__item-wrap horizontal-scroll__item-wrap--first-no-padding u-margin-b--md">
  </ul>
</div>`;

const addButtonsContainer = ($container, $checkboxes, { clearAllText }) => {
  const $buttonContainer = $(createContainerButtons(clearAllText));
  const $clearAllButton = $buttonContainer.find('button');

  $container.prepend($buttonContainer);

  $clearAllButton.on('click', () => {
    $checkboxes.each((index, checkbox) => {
      if (checkbox.checked) {
        $(checkbox).prop('checked', false).trigger('change');
      }
    });
  });

  return {
    $buttonListContainer: $buttonContainer,
    $buttonList: $buttonContainer.find('ul'),
  };
};

const addButtonToList = ($checkbox, $buttonList) => {
  const innserSpan = $checkbox.next().children('span');
  let checkboxText;
  if (innserSpan.length) {
    checkboxText = innserSpan.eq(0).text();
  } else {
    checkboxText = $checkbox.next().text();
  }

  const $filterButton = $(createFilterButton(checkboxText));

  $buttonList.append($filterButton);
  $filterButton.on('click', () => {
    $checkbox.prop('checked', false).trigger('change');
  });
  return $filterButton;
};

const countChecked = ($checkboxes) => $checkboxes.filter(':checked').length;

const checkButtonListVisibility = ($buttonListContainer, $checkboxes) => {
  if (countChecked($checkboxes)) {
    $buttonListContainer.removeClass('u-hide');
    return;
  }

  $buttonListContainer.addClass('u-hide');
};

const initActiveButtons = ($buttonListContainer, $buttonList, $checkboxes) => {
  $checkboxes.each((index, checkbox) => {
    const $checkbox = $(checkbox);
    let $filterButton;

    if (checkbox.checked) {
      $filterButton = addButtonToList($checkbox, $buttonList);
    }

    $checkbox.on('change', () => {
      if (checkbox.checked) {
        $filterButton = addButtonToList($checkbox, $buttonList);
      } else {
        $filterButton.remove();
      }
      checkButtonListVisibility($buttonListContainer, $checkboxes);
    });
  });
};

/**
 * Initializes productFilterActiveButton.
 * @param {HTMLElement} container - filter container
 * @param {Object} options - Options used for wiring up the plugin
 * @see DEFAULTS
 */
export default function productFilterActiveButton(container, options = {}) {
  const $container = $(container);
  const opts = mergeOptions(DEFAULTS, options, $container);
  const $count = $(opts.filterCount);
  const $checkboxes = $container.find('input[type="checkbox"]');

  const { $buttonListContainer, $buttonList } = addButtonsContainer($container, $checkboxes, opts);
  initActiveButtons($buttonListContainer, $buttonList, $checkboxes, $count);
  checkButtonListVisibility($buttonListContainer, $checkboxes);
  $container.productFilterCount();
}

registerJQueryPlugin(PLUGIN_NAME, productFilterActiveButton);



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/product-filter-active-button.js